
import { PuttSituation } from "@/types/golf";

export const wedging30m: PuttSituation = {
  id: 11,
  name: "Wedging 30m",
  image: "/lovable-uploads/7f58f0f6-0fc5-41ba-8bfd-1aeaed3176db.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point F=30m disposée entre le bord du green et un trou à 15 m minimum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "F", distance: 30, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 40 },
    { points: 1, index: 37 },
    { points: 2, index: 34 },
    { points: 3, index: 31 },
    { points: 4, index: 28 },
    { points: 5, index: 25 },
    { points: 6, index: 22 },
    { points: 7, index: 19 },
    { points: 8, index: 16 },
    { points: 9, index: 13 },
    { points: 10, index: 10 },
    { points: 11, index: 7 },
    { points: 12, index: 4 },
    { points: 13, index: 1 },
    { points: 14, index: -2 },
    { points: 15, index: -5 },
    { points: 16, index: -8 },
  ],
};
